// @flow

import React, { Component } from 'react';
import type { Node, ComponentType } from 'react';
import { Heading } from '@riseart/common';
import { Overlay, OverlayHeader, OverlayBody, OverlayContainer } from '@riseart/layout';

type Props = {
  title: Node | string,
  component: ComponentType<*>,
  children: Node,
  open?: boolean,
  onToggle?: Function,
};
type State = { isOpened: boolean };

/**
 * EnquireOverlay
 */
export class EnquireOverlay extends Component<Props, State> {
  handleClose: Function;

  /**
   * constructor
   * @param {Props} props
   */
  constructor(props: Props) {
    super(props);

    this.state = { isOpened: props.open || false };
    this.bindMethods();
  }

  /**
   * handleClose
   * @param {Event} e
   */
  handleClose(e: Event) {
    e.preventDefault();
    this.setState(
      (state) => ({ isOpened: !state.isOpened }),
      () => {
        if (typeof this.props.onToggle === 'function') {
          this.props.onToggle(this.state.isOpened);
        }
      },
    );
  }

  /**
   * bindMethods
   */
  bindMethods() {
    this.handleClose = this.handleClose.bind(this);
  }

  /**
   * render
   */
  render() {
    const { title, children, component: RenderedForm } = this.props;
    const actionElement = React.cloneElement(React.Children.only(children), {
      onClick: this.handleClose,
    });

    return (
      <React.Fragment>
        {actionElement}
        {this.state.isOpened ? (
          <Overlay isVisible type="semitransparent" size="medium" onClose={this.handleClose}>
            <OverlayContainer>
              <OverlayHeader border={false}>
                <Heading tag="h3" level="3">
                  {title}
                </Heading>
              </OverlayHeader>
              <OverlayBody>
                <RenderedForm onClose={this.handleClose} />
              </OverlayBody>
            </OverlayContainer>
          </Overlay>
        ) : null}
      </React.Fragment>
    );
  }
}
